import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getConversationQueryKey } from "modules/conversations/lib/conversationQuery"
import { getCustomerNotesQueryKey } from "modules/notes/lib/customerNotesQuery"

type Params = {
  id: string
  conversationId: string
  customerId?: string
}

export function useDeleteNoteMutation() {
  const queryClient = useQueryClient()

  return useMutation<void, Error, Params>({
    mutationFn: async ({ id }) => {
      await axios.delete(`/notes/${id}`)
    },
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: getConversationQueryKey(variables.conversationId),
      })
      if (variables.customerId) {
        queryClient.invalidateQueries({
          queryKey: getCustomerNotesQueryKey(variables.customerId),
        })
      }
    },
  })
}
